import { Button, Row, SelectorArchivos, Stack, TextField } from "@/components";
import { ACCEPT_FOTO, rutaFoto } from "@/lib/avance";
import type { useFormularioNovedad } from "./useFormularioNovedad";

/** Las fotos de una novedad (ya subidas y por subir), dentro de `FormularioNovedad` o de `FormularioCumplido`. */
export function FotosNovedad({ fid, f }: { fid: number; f: ReturnType<typeof useFormularioNovedad> }) {
  return (
    <Stack espacio={2}>
      <Row justificar="entre">
        <h3 className="text-chico font-medium text-texto">Fotos</h3>
        <SelectorArchivos etiqueta="Agregar fotos a la novedad" textoBoton="Agregar fotos" accept={ACCEPT_FOTO} multiple deshabilitado={f.lugares <= 0 || f.guardando} onElegir={f.elegirFotos} />
      </Row>
      {f.fotos.length > 0 && (
        <ul aria-label="Fotos cargadas" className="grid grid-cols-4 gap-1.5">
          {f.fotos.map((foto, i) => {
            const nombre = foto.epigrafe ?? `foto ${i + 1}`;
            return (
              <li key={foto.id} className="flex flex-col gap-1">
                <img src={rutaFoto(fid, foto.id, "miniatura")} alt={nombre} loading="lazy" className="aspect-[4/3] w-full rounded-control object-cover" />
                <Button type="button" variante="fantasma" tamanio="sm" aria-label={`Borrar foto ${i + 1}: ${nombre}`} onClick={() => void f.borrarFoto(foto)}>
                  Borrar
                </Button>
              </li>
            );
          })}
        </ul>
      )}
      {f.pendientes.length > 0 && (
        <ul aria-label="Fotos para subir" className="flex flex-col gap-3">
          {f.pendientes.map((p) => (
            <li key={p.clave} className="flex flex-col gap-2 rounded-control border border-borde p-3">
              <Row justificar="entre">
                <span className="truncate text-chico">{p.archivo.name}</span>
                <Button type="button" variante="fantasma" tamanio="sm" aria-label={`Quitar ${p.archivo.name}`} onClick={() => f.quitarPendiente(p.clave)}>
                  Quitar
                </Button>
              </Row>
              <TextField etiqueta={`Epígrafe de ${p.archivo.name}`} value={p.epigrafe} maxLength={120} onChange={(e) => f.cambiarEpigrafe(p.clave, e.target.value)} />
            </li>
          ))}
        </ul>
      )}
      <p className="text-chico text-texto-suave">Hasta 10 fotos de 10 MB cada una. Se guardan sin la ubicación del teléfono.</p>
    </Stack>
  );
}
